<template>
  <div id="kudos-modal">
    <font-awesome-icon
      class="close-icon"
      :icon="'xmark'"
      size="4x"
      @click="cancel"
    />
    <div class="row">
      <div class="col-12 d-flex">
        <div class="col-2">
          <div class="email-image-wrapper">
            <img
              class="kudos-icon"
              src="/static/images/icons/kudos-icon.png"
              alt=""
            />
          </div>
        </div>
        <div class="col-10">
          <base-input
            :placeHolder="$t('kudos.modal.addressee.placeholder')"
            @baseInputValue="emailChanged($event)"
            :text="email"
            :isInvalid="!isEmailValid && this.email != null"
            class="mb-2"
          />
          <base-input
            :placeHolder="$t('kudos.modal.addresseeName.placeholder')"
            @baseInputValue="nameChanged($event)"
            :text="name"
            :isInvalid="!isNameValid && this.name != null"
            class="mb-2"
          />
          <textarea-autosize
            :placeholder="$t('feedback.modal.input.placeholder')"
            :class="{ 'reason-input': true, 'animate-shake': '' }"
            ref="reason"
            v-model="reason"
            :min-height="120"
            :max-height="150"
            maxlength="200"
            @blur.native="reasonChanged($event.target.value)"
          />
          <span class="character-count">{{ reasonCount }}/200</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="how-it-works-title" @click="toggleHowItWorks">
          {{ $t('kudos.modal.howItWorksTitle') }}
        </div>
        <transition name="slide">
          <div class="how-it-works" v-show="isHowItWorksVisible">
            <div class="description-text">
              {{ $t('kudos.modal.descriptionText') }}
            </div>
            <div class="alert-text">
              {{ $t('kudos.modal.alertText') }}
            </div>
          </div>
        </transition>
      </div>
      <div class="col-12">
        <base-button
          @click="send"
          :text="$t('kudos.modal.button.title')"
          :disabled="isFormInvalid"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseInput from '@/components/shared/elements/BaseInput';
import BaseButton from '@/components/shared/elements/BaseButton';

export default {
  name: 'KudosModal',
  components: { BaseInput, BaseButton },
  data() {
    return {
      email: undefined,
      name: undefined,
      reason: '',
      isHowItWorksVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'users/loggedInUserProfile',
    }),
    reasonCount() {
      if (this.reason) {
        return this.reason.length;
      }
      return 0;
    },
    isEmailValid() {
      const emailRegex =
        /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,6})$/;
      const result = emailRegex.test(String(this.email).toLowerCase());
      return result;
    },
    isNameValid() {
      const nameRegex = /^.{2,}$/;
      const result = nameRegex.test(String(this.name).toLowerCase());
      return result;
    },
    isFormInvalid() {
      return (
        !this.isEmailValid ||
        !this.email ||
        this.reason.length < 5 ||
        !this.name ||
        !this.isNameValid
      );
    },
  },
  methods: {
    ...mapActions({
      create: 'kudos/create',
    }),
    emailChanged(email) {
      this.email = email;
    },
    nameChanged(name) {
      this.name = name;
    },
    reasonChanged(reason) {
      this.reason = reason;
    },
    toggleHowItWorks() {
      this.isHowItWorksVisible = !this.isHowItWorksVisible;
    },
    cancel() {
      this.$eventBus.closeModal();
    },
    send() {
      this.create({
        userId: this.loggedInUser._id,
        companyId: this.loggedInUser.companyId,
        kudo: {
          email: this.email,
          name: this.name,
          reason: this.reason,
        },
      }).then((kudo) => {
        const path = `kudos/${kudo.code}/${kudo._id.toString().slice(0, 6)}`;
        const sTitle = this.$t('kudos.modal.success.title');
        const sMessage = this.$t('kudos.modal.success.message');
        this.$swal({
          title: sTitle,
          icon: 'success',
          html: `
          <lottie-player
      src="/static/images/kudos/confetti.json"
      background="transparent"
      speed="0.5"
      loop
      style="width: 200%; height: 200%; position: absolute; left: -50%; bottom: -80%; transform: translateY(-80%);"
      autoplay
    ></lottie-player>
    <div style='font-size: 1rem; font-weight: bold;margin-bottom: 20px;'>${sMessage}</div>
    <a style="font-weight:bold;" href="https://motivac.io/${path}" target="_blank">Click here</a>`,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!',
        });
        this.cancel();
      });
    },
  },
};
</script>

<style scoped lang="scss">
#kudos-modal {
  min-width: 450px;
  max-width: 600px;
  text-align: left;
  @media (min-width: 992px) {
    min-width: 650px;
  }
  transition: max-height 0.45s ease-in;
  padding: 20px;
  .reason-input {
    border: none;
    margin-left: 15px;
    flex: 1 33.33%;
    outline: none;
    height: 120px;
    width: 100%;
    background-color: rgba(53, 54, 61, 0.035);
    padding: 15px;
    border-radius: 8px;
  }
  .email-image-wrapper {
    width: 80px;
    height: 80px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .email-icon {
    color: #ddd;
    border: 1px solid #ddd;
    border-radius: 40px;
    padding: 10px;
  }
  .character-count {
    position: absolute;
    bottom: 10px;
    right: 20px;
    font-size: 12px;
    color: #aaa;
    font-weight: bold;
  }
  .how-it-works-title {
    color: #aaa;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    margin: 10px 0;
  }
  .description-text,
  .alert-text {
    color: #aaa;
    font-weight: bold;
    font-size: 14px;
    text-align: left;
    margin: 10px 0;
  }
  .alert-text {
    font-size: 12px;
    color: $secondary-color;
  }
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    font-size: 16px;
    color: #aaa;
    cursor: pointer;
    &:hover {
      color: $base-font-color;
    }
  }
  .kudos-icon {
    max-height: 100px;
  }
  .how-it-works {
  }
}
</style>